export default __webpack_public_path__ + "static/media/happyclient2.3c8e8fa2.svg";